const translations = {
  BUTTONS: {
    '_goToPairing': 'Tovább a párosításhoz',
    '_downloadOutputFile': 'kimeneti fájl letöltés',
    '_nextPairing': 'Következő párosítás',
    '_startProcessing': 'Feldolgozás indítása',
    '_goToAccountAssignment': 'Tovább a kontírozáshoz',
    '_goToDownload': 'Tovább a letöltéshez',
    '_rules': 'Szabályok',
    '_savedPartners': 'Partnerek',
    '_downloadOutputFileBank': 'kimeneti fájl letöltés (Vevő)',
    '_downloadOutputFileBankCard': 'kimeneti fájl letöltés (Bankkártya)',
    '_downloadOutputFileCash': 'kimeneti fájl letöltés (Készpénz)',
    '_processing': 'Feldolgozás alatt...',
    '_back': 'Vissza',
    '_showProcessedItems': 'Feldolgozott tételek megjelenítése',
    '_hideProcessedItems': 'Feldolgozott tételek elrejtése',
    '_savePairing': 'Párosítás mentése',
    '_skipPairing': 'Párosítás kihagyása',
    '_startPayment': 'Fizetés indítása',
    '_save': 'Mentés',
    '_uploadRules': 'Feltöltése',
    '_delete': 'Törlés',
  },
  COMMON: {
    '_processingPleaseWait': 'Kimenet generálása folyamatban. Kérjük várja meg amíg a feldolgozás befejeződik.',
	'_downloadRules': 'Szabályok letöltése',
	'_uploadRules': 'Szabályokat tartalmazó XLSX fájl kiválasztása',
    '_printRules': 'Szabályok nyomtatása',
    '_deleteAllRules': 'Összes szabály törlése',
    '_processedSuccessfully': 'A feldolgozás sikeresen megtörtént.',
    '_rules': 'Szabályok',
    '_identifier': 'Azonosító',
    '_typeOfRule': 'Szabály típusa',
    '_position': 'Sorrend',
    '_updatedAt': 'Módosítva',
    '_finalRule': 'Végleges',
    '_temporarirlyRule': 'Egyszeri',
    _hu: 'Magyarországi',
    _non_eu: 'EU-n kívüli',
    _eu: 'EU-s',
    _editRuleText: 'Szabály szerkesztése',
    _showRuleText: 'Szabály megtekintése',
    '_save': 'Mentés',
    '_close': 'Bezárás',
    '_noRulesFound': 'Ehez a céghez még nem lettek szabályok hozzárendelve.',
    '_bankRulesInfoText': 'Kérjük, csak azokat a mezőket töltse ki, melyek szeretné, hogy feltételként szolgáljanak a szabály alkalmazására.'
  },
  CUSTOMER: {
    '_title': 'Számlázóprogramból kinyert NAV export kontírozása és könyvelése..',
    '_description': 'Kérjük, adja meg a kiválasztott cég főkönyvi struktúrájának megfelelő Főkönyvi számokat, majd töltse fel a kért adatokat a Számlázó programból és válassza ki az Ön által használt Könyvelőprogramot.',
    '_createRulesAndProcess': 'Szabály létrehozása és feldolgozása',
    '_oneTimeProcessing': 'Egyszeri feldolgozás',
    '_typeOfTraffic': 'Forgalom típusa',
    '_day': 'Értéknap',
    '_sum': 'Összeg',
    '_invoiceNumber': 'Számlaszám',
    '_positionNumber': 'Poz szám',
    '_positionNumberCountry': 'Poz szám ország',
    '_companyName': 'Cég név',
    '_paymentType': 'Fiz. mód',
    '_announcement': 'Közlemény',
    '_v_sz': 'V/Sz',
    '_VAT': 'ÁFA kulcs',
    '_POSITION': 'Sorrend',
    '_collectorCode': 'Gyűjtő kód',
    '_mainBookNumber': 'Fők. szám',
	'_legalTitle': 'Jogcímkód',
    '_taxNumber': 'Adószám',
    '_orderNumberStat': 'Rendelésszám stat.',
    '_vatDegreeNumber': 'ÁFA fők. szám',
    '_bookingIntervall': 'Könyvelt időszak:',
    'hufCashInvoicesRegistration': 'KÉSZPÉNZES FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfforgeingCurrenciesCashInvoices': 'KÉSZPÉNZES DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfTransferedHufInvoices': 'ÁTUTALÁSOS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfForgeinTransferedInvoices': 'ÁTUTALÁSOS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',

    'registrationNumberOfHufBankCardTransaction': 'BANKKÁRTYÁS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfBankCardTransaction': 'BANKKÁRTYÁS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfHufCodTransaction': 'UTÁNVÉTES FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfCodTransaction': 'UTÁNVÉTES DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfHufPayPalTransaction': 'PAYPAL-OS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfPayPalTransaction': 'PAYPAL-OS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',

    _rulesTitle: 'Szabályok szerkesztése',
    _partnersDeleteTitle: 'Mentett partnerek törlése',
    _rulesDescription: 'A kiválasztott céghez tartozó, korábbi kontírozások során mentett szabályok szerkesztése.',
    _editRule: 'Szerkesztés',
    _deleteRule: 'Törlés',
    _city: 'Város',
    _voucher_nb: 'Biz. szám',
    _startProcessingConfirmation: 'Biztos indítani szeretné a kontírozott tételek feldolgozásat?'
  },
  SUPPLIER: {
    '_title': 'Számlázóprogramból kinyert NAV export kontírozása és könyvelése..',
    '_description': 'Kérjük, adja meg a kiválasztott cég főkönyvi struktúrájának megfelelő Főkönyvi számokat, majd töltse fel a kért adatokat a Számlázó programból és válassza ki az Ön által használt Könyvelőprogramot.',
    '_createRulesAndProcess': 'Szabály létrehozása és feldolgozása',
    '_oneTimeProcessing': 'Egyszeri feldolgozás',
    '_typeOfTraffic': 'Forgalom típusa',
    '_day': 'Értéknap',
    '_sum': 'Összeg',
    '_invoiceNumber': 'Számlaszám',
    '_companyName': 'Cég név',
    '_orderNumberStat': 'Rendelésszám stat.',
    '_supplierName': 'Szállítóneve',
    '_positionNumberCountry': 'Poz szám ország',
    '_paymentType': 'Fiz. mód',
    '_announcement': 'Közlemény',
    '_v_sz': 'V/Sz',
    '_VAT': 'ÁFA kulcs',
    '_POSITION': 'Sorrend',
    '_collectorCode': 'Gyűjtő kód',
    '_mainBookNumber': 'Fők. szám',
    '_legalTitle': 'Jogcímkód',
    '_taxNumber': 'Adószám',
    '_vatDegreeNumber': 'ÁFA fők. szám',
    '_bookingIntervall': 'Könyvelt időszak:',
    'hufCashInvoicesRegistration': 'KÉSZPÉNZES FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfforgeingCurrenciesCashInvoices': 'KÉSZPÉNZES DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfTransferedHufInvoices': 'ÁTUTALÁSOS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationOfForgeinTransferedInvoices': 'ÁTUTALÁSOS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',

    'registrationNumberOfHufBankCardTransaction': 'BANKKÁRTYÁS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfBankCardTransaction': 'BANKKÁRTYÁS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfHufCodTransaction': 'UTÁNVÉTES FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfCodTransaction': 'UTÁNVÉTES DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfHufPayPalTransaction': 'PAYPAL-OS FORINTOS SZÁMLÁK RÖGZÍTÉSE',
    'registrationNumberOfPayPalTransaction': 'PAYPAL-OS DEVIZÁS SZÁMLÁK RÖGZÍTÉSE',

    _rulesTitle: 'Szabályok szerkesztése',
    _partnersDeleteTitle: 'Mentett partnerek törlése',
    _rulesDescription: 'A kiválasztott céghez tartozó, korábbi kontírozások során mentett szabályok szerkesztése.',
    _editRule: 'Szerkesztés',
    _deleteRule: 'Törlés',
    _city: 'Város',
    _voucher_nb: 'Biz. szám',
    _startProcessingConfirmation: 'Biztos indítani szeretné a kontírozott tételek feldolgozásat?'
  },
  STEPS: {
    '_upload': 'Feltöltés',
    '_accountAssignment': 'Kontírozás',
    '_download': 'Letöltés',
  },
  LOGIN: {

  },
  COMPANY: {
    '_noCompaniesFoud': 'Nincs még cég hozzáadva.',
    '_name': 'Név',
    '_processedItemsCount': 'Kontírozott tételek',
    '_bookingIntervall': 'Utolsó könyvelt időszak',
    '_operations': 'Műveletek',
    '_addComapny': 'Cég hozzáadása',
    '_editComapny': 'Cég szerkesztése',
    '_save': 'Mentés',
    '_close': 'Bezárás'
  },
  VALIDATIONS: {
    '_startDateEndDate': 'Kezdő dátum nem lehet nagyobb mint a zárás dátum.'
  }
}
module.exports = translations


// WEBPACK FOOTER //
// ./src/i18/hu.js